var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92969 3.25C3.51547 3.25 3.17969 3.58579 3.17969 4C3.17969 4.41421 3.51547 4.75 3.92969 4.75V3.25ZM3.92969 4.75H6.73686V3.25H3.92969V4.75ZM8.61631 6.29078L11.4091 20.2546L12.8799 19.9604L10.0872 5.9966L8.61631 6.29078ZM6.73686 4.75C7.6505 4.75 8.43713 5.39488 8.61631 6.29078L10.0872 5.9966C9.76778 4.39957 8.36553 3.25 6.73686 3.25V4.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.478 24.5631C26.8922 24.5631 27.228 24.2273 27.228 23.8131C27.228 23.3989 26.8922 23.0631 26.478 23.0631V24.5631ZM10.6036 20.0916L10.5968 19.3416L10.6036 20.0916ZM26.7351 18.6224L27.4713 18.7652L26.7351 18.6224ZM28.264 10.7426L27.5277 10.5997L28.264 10.7426ZM9.88729 9.90527H26.9551V8.40527H9.88729V9.90527ZM27.5277 10.5997L25.9988 18.4795L27.4713 18.7652L29.0003 10.8854L27.5277 10.5997ZM25.1216 19.2096L10.5968 19.3416L10.6104 20.8416L25.1353 20.7095L25.1216 19.2096ZM10.6205 24.5631H26.478V23.0631H10.6205V24.5631ZM8.00977 21.9523C8.00977 23.3942 9.17865 24.5631 10.6205 24.5631V23.0631C10.0071 23.0631 9.50977 22.5658 9.50977 21.9523H8.00977ZM10.5968 19.3416C9.16423 19.3547 8.00977 20.5197 8.00977 21.9523H9.50977C9.50977 21.3428 10.0009 20.8471 10.6104 20.8416L10.5968 19.3416ZM25.9988 18.4795C25.9171 18.9005 25.5504 19.2057 25.1216 19.2096L25.1353 20.7095C26.2771 20.6991 27.2538 19.8863 27.4713 18.7652L25.9988 18.4795ZM26.9551 9.90527C27.3218 9.90527 27.5976 10.2397 27.5277 10.5997L29.0003 10.8854C29.2497 9.59962 28.2649 8.40527 26.9551 8.40527V9.90527Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2737,
    cy: 25.9055,
    r: 2.09397,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9377,
    cy: 25.9055,
    r: 2.09397,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ee6f99a1b1dc4e5cfd3339e12645c05f.svg";
export { ForwardRef as ReactComponent };